import request from '../libs/request';

const res = 'ProcessDef';

export default {
  save(data) {
    return request({
      url: `api/${res}/save`,
      method: 'post',
      data
    });
  },
  publish(data) {
    return request({
      url: `api/${res}/publish`,
      method: 'post',
      data
    });
  },
  active(id) {
    return request({
      url: `api/${res}/active`,
      method: 'post',
      data: {
        id
      }
    });
  },
  getChart(params) {
    return request({
      url: `api/${res}/getChart`,
      method: 'get',
      params
    });
  }
};
